const en = {
  loading: 'Loading carpools...',
  loadFailed: 'Failed to load carpools',
  title: 'Carpools',
  description: 'Rides offered in the app, to or from the festival.',
  empty: 'No carpools yet.',
  created: 'Created',
  direction: 'Direction',
  departure: 'Departure',
  user: 'User',
  phone: 'Phone',
  note: 'Note',
  coordinates: 'Coordinates',
  actions: 'Actions',
  toFestival: 'To the festival',
  fromFestival: 'From the festival',
  /** A carpool's direction in its pill, from the API: to or from (the festival) */
  directionLabel: (direction: string) => direction,
  deleteTitle: 'Delete carpool',
  deleteConfirm: (userName: string) => `Are you sure you want to delete this carpool from ${userName}?`,
  deleting: 'Deleting...',
  deleteFailed: 'Failed to delete carpool',
};

const DIRECTION_LABELS: Record<string, string> = { to: 'aller', from: 'retour' };

const fr: typeof en = {
  loading: 'Chargement des covoiturages...',
  loadFailed: 'Impossible de charger les covoiturages',
  title: 'Covoiturages',
  description: "Trajets proposés dans l'app, vers ou depuis le festival.",
  empty: "Aucun covoiturage pour l'instant.",
  created: 'Créé le',
  direction: 'Sens',
  departure: 'Départ',
  user: 'Utilisateur',
  phone: 'Téléphone',
  note: 'Note',
  coordinates: 'Coordonnées',
  actions: 'Actions',
  toFestival: 'Vers le festival',
  fromFestival: 'Depuis le festival',
  directionLabel: direction => DIRECTION_LABELS[direction] ?? direction,
  deleteTitle: 'Supprimer le covoiturage',
  deleteConfirm: userName => `Voulez-vous vraiment supprimer ce covoiturage proposé par ${userName}\u00a0?`,
  deleting: 'Suppression...',
  deleteFailed: 'Impossible de supprimer le covoiturage',
};

const messages = { en, fr };
export default messages;
